import { zodResolver } from "apps/web/src/utils/zodResolver";
import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import DialogTitle from "apps/web/src/componentLibrary/DialogTitle";
import { getViewAttendancePath } from "apps/web/src/pages/Auth/Org/ViewAttendance/ViewAttendanceRouter";
import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom-v5-compat";
import { ViewAttendanceForm } from "./ViewAttendanceForm";
import { ViewAttendanceFormSchema, ViewAttendanceFormType } from "./ViewAttendanceFormSchema";

interface ViewAttendanceDialogProps {
  open: boolean;
  onClose: () => void;
}

export const ViewAttendanceDialog = ({ open, onClose }: ViewAttendanceDialogProps) => {
  const navigate = useNavigate();

  const form = useForm<ViewAttendanceFormType>({
    resolver: zodResolver(ViewAttendanceFormSchema),
    mode: "onChange",
  });

  const { isValid } = form.formState;
  const handleClose = () => {
    onClose();
  };

  const submit = ({ startDate, endDate }: ViewAttendanceFormType) => {
    const startDateEndDateParamString = `?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`;
    navigate(`${getViewAttendancePath()}${startDateEndDateParamString}`);
  };

  return (
    <Dialog
      PaperProps={{
        sx: { height: "400px" },
      }}
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle title="View Attendance Report" onClose={handleClose} />
      <DialogContent sx={{ pt: 0 }}>
        <Typography variant="body2" sx={{ mb: 2 }}>
          A maximum of 7 days can be selected for an attendance report
        </Typography>
        <ViewAttendanceForm form={form} />
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button disabled={!isValid} onClick={form.handleSubmit(submit)}>
            Continue
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
